module.exports = __webpack_public_path__ + "static/media/taobao2_01.4b95a2df.jpg";